/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function() {
  'use strict';
  var tlpsDefinizioneCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name getStyleTabMicro
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
     */
    this.getStyleTabMicro = function(currentTabIndex) {
      if (self.propostaTelepassSrvc.isPraticaNavigabile()) {
        if (self.currentStep && currentTabIndex === self.currentStep.index) {
          return 'ab-step-tabs cliccabile active-read';
        }

        return 'ab-step-tabs cliccabile ab-last-read';
      }

      // Pratica non navigabile
      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'ab-step-tabs';
      }

      if (self.currentStep && currentTabIndex === self.currentStep.index) {
        return 'ab-step-tabs active';
      }

      return 'ab-step-tabs ab-last';
    };

    /**
     * @ngdoc method
     * @name getStyleStepMicro
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
     */
    this.getStyleStepMicro = function(currentTabIndex) {
      if (self.propostaTelepassSrvc.isPraticaNavigabile()) {
        return 'step read';
      }

      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'step success';
      }

      return 'step';
    };

    /**
     * @ngdoc method
     * @name microTabClicked
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Apre il micro-tab selezionato solo se tutte le domande sono state compilate
     * @param {Object} tab - il micro-tab selezionato
     */
    this.microTabClicked = function(tab) {
      if (self.propostaTelepassSrvc.isPraticaNavigabile()) {
        self.currentStep = tab;
      }
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  tlpsDefinizioneCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDefinizione/tlpsDefinizione.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var tlpsDefinizioneComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: tlpsDefinizioneCtrl,
    controllerAs: 'definizioneProdCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsDefinizione', tlpsDefinizioneComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsDefinizione/tlpsDefinizione.cmpt.js
// module id = 28
// module chunks = 0